import AnimalCard from '../components/AnimalCard';
import AddressInput from '../components/UI/AddressInput';
import ExpandableTooltip from '../components/UI/ExpandableTooltip';
import ExpandableTooltipWrapper from '../components/UI/ExpandableTooltipWrapper';
import InputDate from '../components/UI/InputDate';
import InputField from '../components/UI/InputField';
import InputPhone from '../components/UI/InputPhone';
import RangeSelector from '../components/UI/RangeSelector';
import TenantForm from '../components/UI/TenantForm';
import Tooltip from '../components/UI/Tooltip';
import UploadDocument from '../components/UI/UploadDocument';
// Add other components as needed

/**
 * A mapping of component names to their corresponding React component types.
 * 
 * This object allows dynamic access to components by their string keys.
 * Each key represents the name of a component, and the value is the React component itself.
 *
 * @remarks
 * Useful for rendering components dynamically based on configuration or data-driven approaches.
 *
 * @example
 * ```tsx
 * const Component = componentMap['AnimalCard'];
 * return <Component {...props} />;
 * ```
 */
const componentMap: Record<string, React.ComponentType<any>> = {
  AnimalCard,
  InputDate,
  InputField,
  Tooltip,
  ExpandableTooltip,
  ExpandableTooltipWrapper,
  UploadDocument,
  TenantForm,
  RangeSelector,
  InputPhone,
  AddressInput
};

export default componentMap;
